
export enum TipoIndirizzo{
   RESIDENZA=0,
   NASCITA=1,
}

export class IndirizzoData {
   id?: string;
   citta?: string;
   provincia?: string;
   indirizzo?: string;
   cap?: any;
   latitudine?: string;
   longitudine?: string;
   regione?: any;
   stato?: any;
   indirizzo_citta_nome?:string;
   indirizzo_regione_nome?:string;
}

export class Indirizzo {

   data:IndirizzoData = {}

   constructor(data) {
      // assegno al mio oggetto data (è un json)
      if(!data) data = {}
      Object.assign(this.data, data)
   }



}

